import {
    DictionaryParams,
    Dictionaries,
    DictionaryTie,
    DictionaryViewModel as DictionaryListParams,
    CreateDictionaryItemBody as CreateDictionaryItemParams,
    UpdateDictionaryItemBody as UpdateDictionaryItemParams,
} from 'chaika-types';
import type * as BackendTypes from 'chaika-types';

export interface DictionaryResponse {
    items: Dictionaries;
}

export type {
    Dictionaries,
    DictionaryParams,
    DictionaryTie,
    UpdateDictionaryItemParams,
    CreateDictionaryItemParams,
    DictionaryListParams,
};

export interface DictionaryListResponse {
    dictionaries: DictionaryListParams[];
}
export interface DictionaryFindOption
    extends Omit<BackendTypes.DictionarySearchQuery, 'names' | 'ids' | 'parentId' | 'childId'> {
    ids?: string | string[];
    names?: string | string[];
    parentId?: string | string[];
    childId?: string | string[];
}

export const enum FrontendDictionaryNames {
    VaccinationType = 'VaccinationType',
    Vaccines = 'Vaccines',
    VaccinationStage = 'VaccinationStage',
    TaskType = 'TaskType',
    VaccinesDesieses = 'vaccinesDesieses',
    AllowToAssistantEntryType = 'allowToAssistantEntryType',
    LegalEntityVat = 'legalEntityVat',
}

export enum VaccineDeliveryMethod {
    Intramuscular = 'внутримышечный',
    Aerosol = 'аэрозольный',
    Oral = 'пероральный',
    Intradermal = 'внутрикожный',
    Hypodermal = 'подкожный',
}
